import { render, staticRenderFns } from "./HampaPay.vue?vue&type=template&id=2202bf48&scoped=true&"
import script from "./HampaPay.vue?vue&type=script&lang=js&"
export * from "./HampaPay.vue?vue&type=script&lang=js&"
import style0 from "./HampaPay.vue?vue&type=style&index=0&id=2202bf48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2202bf48",
  null
  
)

export default component.exports